import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ROUTE_CONSTANTS } from 'constants/route';
import { isContentPage } from 'helpers/page';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#37609d',
    padding: '1rem',
  },
  link: {
    color: '#fff',
    display: 'flex',
    '&:hover': {
      color: '#fff',
    },
  },
  icon: {
    flexBasis: '40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

const Breadcrumb = () => {
  const location = useLocation();
  const classes = useStyles();

  return isContentPage(location) ? (
    <div data-testid="breadcrumb_root" className={`${classes.root} print-breadcrumb`}>
      <Link color="inherit" to={ROUTE_CONSTANTS.HOME} className={classes.link}>
        <div className={classes.icon}>
          <ArrowBackIcon />
        </div>
        <div className={classes.text}>Back to ISR Home</div>
      </Link>
    </div>
  ) : null;
};

export default Breadcrumb;
